module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="form-horizontal col-md-offset-3 col-xs-offset-3 col-md-6 col-xs-6">\r\n    <h4 class="center">Leave a feedback</h4>\r\n    <div>\r\n        <div class="form-group">\r\n            <input class="form-control" id="name" placeholder="Enter your name"/>\r\n        </div>\r\n        <div class="form-group">\r\n            <input class="form-control" id="email" placeholder="Enter your e-mail"/>\r\n        </div>\r\n        <div class="form-group">\r\n            <textarea class="form-control" rows="10" id="text"></textarea>\r\n        </div>\r\n        <div class="left-buttons">\r\n            <button type="button" class="btn btn-success" id="send" disabled>Send</button>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<div id="success-dialog"></div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/help/help-feedback-view.html
// module id = 512
// module chunks = 0